<template>
  <form @submit.prevent="submit()">
    <div class="row align-items-center">
      <div class="col-6 logo logo-sm">
        <img :src="window.fileDomain + '/logo/portal/' + window.hostId + '.png'"/>
      </div>
      <div class="col-6 text-end">
        <button type="button" @click.prevent="$emit('close')" class="btn btn-link btn-x px-0 d-inline-flex">
          <i class="fa-light fa-xmark-large"></i>
        </button>
      </div>
    </div>
    <template v-if="!reset">
      <div>
        <h6>{{ bundle.id_100 }}</h6>
        <global-errors :value="loginErrors"/>
        <input-text id="username" v-model="loginForm.username" :placeholder="bundle.id_97"/>
        <input-secret id="password" v-model="loginForm.password" :placeholder="bundle.id_98"/>
        <div class="row other">
          <div class="col-auto">
            <select-boolean-checkbox id="remember" v-model="loginForm.remember" :option-label="bundle.id_99"
                                     class="mb-0"/>
          </div>
          <div class="col text-end">
            <a href="#" @click.prevent="reset = true" class="link-primary fw-increase-2">{{ bundle.id_101 }}</a>
          </div>
        </div>
      </div>
      <div>
        <button type="submit" class="btn btn-primary w-100">
          {{ bundle.id_100 }}
          <i v-if="submitting || redirecting" class="spinner-grow spinner-grow-sm"/>
        </button>
        <div class="text-center mt-3">
          <smart-link :value="signUpLink" class="link-primary"/>
        </div>
      </div>
    </template>
    <template v-else>
      <div>
        <h6>{{ bundle.id_264 }}</h6>
        <p>{{ bundle.id_271 }}</p>
        <template v-if="!resetSuccess">
          <input-text id="email" v-model="resetForm.email" :placeholder="bundle.id_178" :errors="resetErrors.email"/>
        </template>
        <template v-else="">
          <p class="alert alert-success">{{ bundle.id_270 }}</p>
        </template>
      </div>
      <div v-if="!resetSuccess">
        <button type="submit" class="btn btn-primary w-100">
          {{ bundle.id_160 }}
          <i v-if="submitting" class="spinner-grow spinner-grow-sm"/>
        </button>
      </div>
      <div class="text-center mt-3">
        <a href="#" @click.prevent="reset = false" class="link-primary">{{ bundle.id_11380 }}</a>
      </div>
    </template>
  </form>
</template>

<script>
import Vue from "vue";

export default {
  name: "menu-log-in",
  props: {
    signUpLink: {
      type: Object, // LinkData
      required: true
    },
  },
  data: function () {
    return {
      bundle: {
        id_97: "Username",
        id_98: "Password",
        id_99: "Remember",
        id_100: "Log In",
        id_101: "Forgotten?",
        id_160: "160",
        id_178: "Your Email",
        id_264: "Lost username or password",
        id_269: "Unable to send the username and password to your email address. Reason unknown.",
        id_270: "The username and password have been sent to your email. A few minutes may pass, before you receive it.",
        id_271: "Your username and password will be sent to your email. You must specify the same email address as the one specified in your account.",
        id_11380: "Go back to log in",
      },
      reset: false,
      resetSuccess: false,
      loginForm: {
        username: "",
        password: "",
        remember: true
      },
      loginErrors: [],
      resetForm: {
        email: ""
      },
      resetErrors: {},
      submitting: false,
      redirecting: false
    };
  },
  created: function () {
    Vue.$bundle("portal", this.bundle, (bundle) => {
      this.bundle = bundle;
    });
  },
  methods: {
    submit: function () {
      if (!this.reset) {
        this.submitLogin();
      } else {
        this.submitReset();
      }
    },
    submitLogin: function () {
      this.submitting = true;
      this.loginErrors = [];
      window.logIn(
          this.loginForm.username,
          this.loginForm.password,
          this.loginForm.remember,
          () => {
            this.submitting = false;
            this.redirecting = true;
          },
          (messages) => {
            this.submitting = false;
            if (messages) {
              for (let i = 0; i < messages.length; i++) {
                this.loginErrors.push(messages[i].message);
              }
            }
          });
    },
    submitReset: function () {
      this.submitting = true;
      this.$services.resetLoginRequestService.create(this.resetForm.email)
          .then((data) => {
            this.$clearFormErrors(this.resetErrors);
            if (data.status === "ok") {
              this.resetSuccess = true;
            } else {
              this.$showFormErrors(this.resetErrors, data.errors);
            }
          })
          .catch((err) => {
            console.log(err);
            window.logErrorRemotely(err);
          })
          .finally(() => {
            this.submitting = false;
          });
    }
  }
}
</script>

<style scoped lang="less">
h6 {
  font-size: 1.125rem;
  font-weight: 400;
}

.other {
  font-size: .875em;
}
</style>